export default process.env.RAZZLE_PACKAGE === 'production'
  ? '//carphoto.atzuche.com/'
  : '//at-images-test.oss-cn-hangzhou.aliyuncs.com/'
